import { t } from 'i18next';

import { company } from '~/company/Company';

const config = () =>
  company.match({
    mcosmetic: {
      stepsData: [
        {
          textTitle: t('onboarding:chooseLanguage'),
          textDescription: t('onboarding:chooseLanguage'),
          position: 'top',
        },
        {
          textTitle: t('onboarding:enableNotifications:title'),
          textDescription: t('onboarding:enableNotifications:description'),
          position: 'top',
        },
        {
          textTitle: t('onboarding:fastDelivery:title'),
          textDescription: t('onboarding:fastDelivery:description'),
          position: 'top',
        },
        {
          textTitle: t('onboarding:customizeSelection:title'),
          textDescription: t('onboarding:customizeSelection:description'),
          position: 'top',
        },
      ],
    },
    default: {
      stepsData: [
        {
          textTitle: t('onboarding:swiftDelivery:title'),
          textDescription: t('onboarding:swiftDelivery:description'),
          position: 'top',
        },
        {
          textTitle: t('onboarding:spotTheLight:title'),
          textDescription: t('onboarding:spotTheLight:description'),
          position: 'top',
        },
        /*{
    img: company.images.onboarding.unlockComplementary,
    textTitle: t('onboarding:unlockComplementary:title'),
    textDescription: t('onboarding:unlockComplementary:description'),
  },*/
        {
          textTitle: t('onboarding:trackDelivery:title'),
          textDescription: t('onboarding:trackDelivery:description'),
          position: 'top',
        },
        {
          textTitle: t('onboarding:shareThoughts:title'),
          textDescription: t('onboarding:shareThoughts:description'),
          position: 'top',
        },
        {
          textTitle: t('onboarding:referFriend:title'),
          textDescription: t('onboarding:referFriend:description'),
          position: 'top',
        },
        {
          textTitle: t('onboarding:sign_up:title'),
          textDescription: t('onboarding:sign_up:description'),
          position: 'top',
        },
      ],
      additionalData: {
        isVisibleInputLabels: true,
      },
    },
    localee: {
      stepsData: [
        {
          textTitle: '',
          textDescription: '',
          position: '50% 35%',
        },
      ],
      additionalData: {
        backgroundColor: 'var(--brandAtom900)',
        skipButtonText: t('onboarding:shop_now_btn'),
        isVisibleInputLabels: false,
        inputEmailPlaceholder: t('onboarding:sign_up:email_simple_placeholder'),
        inputFirstNamePlaceholder: t(
          'onboarding:sign_up:first_name_simple_placeholder',
        ),
      },
    },
  });

export default () => ({
  ...config(),
  stepsData: config()?.stepsData.map((configItem, index) => ({
    ...configItem,
    img: company.images.onboarding?.[index] || '',
  })),
});
